import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class LockCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'card_lock';
        params.type = CardType.lock;
        params.dragonbonesName = 'lock_key';
        params.armatureName = 'lock';
        params.armatureObjectName = 'lock_armature';
        super.onCreate(params);
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('lock_key', `${CARD_DRAGONBONES_PATH}/LockKey/`);
    }
}
